import { useEffect } from 'react';
import { useAppDispatch } from '../../store';
import { getRally } from '../../api/game-mode/rallies';
import { GAME_DB } from '../../db/game';
import { setRallyInfo } from '../../store/slices/rallyGame';
import { useTranslation } from 'react-i18next';
import { setIsModalOpen, setModalContent } from '../../store/slices/global';
import { MODAL_CONTENT } from '../../app.config.vars/modalContent';
const useFetchRally = (id) => {
    const dispatch = useAppDispatch();
    const { i18n } = useTranslation();
    useEffect(() => {
        const fetchRally = async () => {
            try {
                const rally = await getRally(id);
                if (rally) {
                    await GAME_DB.SET.rallyInfo(rally);
                    dispatch(setRallyInfo(rally));
                }
                else {
                    const rally = await GAME_DB.GET.rallyInfo();
                    if (rally) {
                        dispatch(setRallyInfo(rally));
                    }
                    else {
                        dispatch(setIsModalOpen(true));
                        dispatch(setModalContent(MODAL_CONTENT.somethingWentWrong.key));
                    }
                }
            }
            catch (error) {
                dispatch(setIsModalOpen(true));
                dispatch(setModalContent(MODAL_CONTENT.somethingWentWrong.key));
            }
        };
        fetchRally();
    }, [id, i18n.language]);
};
export default useFetchRally;
